import { render, staticRenderFns } from "./leftSidebar.vue?vue&type=template&id=05450ecd&scoped=true"
import script from "./leftSidebar.vue?vue&type=script&lang=js"
export * from "./leftSidebar.vue?vue&type=script&lang=js"
import style0 from "./leftSidebar.vue?vue&type=style&index=0&id=05450ecd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05450ecd",
  null
  
)

export default component.exports